import module_71fd1376d8c74e46a2a95a77b607ba1c from '../includes/glsl-compat.frag'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\nprecision '+
(obj.highp)+
' float;\n\n'+
(module_71fd1376d8c74e46a2a95a77b607ba1c())+
'\n\nIN vec2 vTexCoordFull;\n\nuniform vec2 uFlash;\nuniform vec4 uTransform;\nuniform float uRotation;\nuniform vec3 uColor1;\nuniform vec3 uColor2;\n\nuniform sampler2D tSpiral;\n\nvec2 getUV(vec2 texCoord, float scale, float rotation){\n  vec2 center = vec2(0.5);\n  mat3 transformationMatrix = mat3(\n    cos(rotation) * scale, -sin(rotation) * scale, 0,\n    sin(rotation) * scale, cos(rotation) * scale, 0,\n    0, 0, 1\n  );\n  return (transformationMatrix * vec3((texCoord - center) * uTransform.zw, 1)).xy + center;// + uTransform.xy;\n}\n\n\nvoid main(void){\n\n  float time = uFlash.y;\n\n  // const vec3 color1 = vec3(0.008,0.282,0.376);\n  // const vec3 color2 = vec3(0.,0.161,0.22);\n  vec3 color1 = uColor1;\n  vec3 color2 = uColor2;\n\n  float p = uFlash.x;\n\n  const float scale0 = 4.0;\n  const float scale1 = 3.0;\n  const float scale2 = 1.5;\n  const float scale3 = 1.0;\n\n  vec2 uv = vTexCoordFull;\n  uv.y = 1.0 - uv.y;\n  uv -= 0.5;\n  uv *= 0.5;\n  uv += 0.5;\n  uv = uv + uTransform.xy;\n\n  float sf_05 = 1.0 / mix(0.00001, 1.0, uFlash.x / 0.5);\n  float sf_1 = 1.0 / mix(0.00001, 3.0, max((uFlash.x - 0.5) / 0.5, 0.0));\n\n  vec2 uv0 = getUV(uv, scale0 * sf_1, uFlash.x * 0.3 * uRotation);\n  vec2 uv1 = getUV(uv, scale1 * sf_05, uFlash.x * 1.5 * uRotation);\n  vec2 uv2 = getUV(uv, scale2 * sf_05, uFlash.x * 2.0 * uRotation);\n  vec2 uv3 = getUV(uv, scale3 * sf_05, uFlash.x * 2.5 * uRotation);\n\n  float c0 = texture2D(tSpiral, uv0).r;\n  float c1 = texture2D(tSpiral, uv1).r;\n  float c2 = texture2D(tSpiral, uv2).r;\n  float c3 = texture2D(tSpiral, uv3).r;\n\n  c0 = step(0.5, c0);\n  c1 = step(0.5, c1);\n  c2 = step(0.5, c2);\n  c3 = step(0.5, c3);\n\n  float ic0 = 1.0 - c0;\n  float ic1 = 1.0 - c1;\n  float ic2 = 1.0 - c2;\n  float ic3 = 1.0 - c3;\n\n  vec3 color;\n  color += color1 * c1;\n  color += color2 * c2 * ic1;\n  color += color1 * c3 * ic1 * ic2;\n  color += color2 * ic1 * ic2 * ic3;\n\n  FragColor.rgb = color;\n  FragColor.a = 1.0 - min(c0 + ic3, 1.0);\n\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
